import React, { useContext, useState } from 'react'
import AbiStatementViewApiUrls from 'src/apiUrls/AbiStatementViewApiUrls'
import { STATEMENT_TYPE } from '../shared'

const StatementDialogContext = React.createContext()

export const useDialogCache = () => useContext(StatementDialogContext)

// INTEGRATION: ideally, this should be a single API url that will retrieve the correct data (entry, monthly, daily; finalized or preliminary) based on the `statementNumber` provided.
const getApiUrl = (stmtNumber, stmtType, finalized) => {
  console.log(stmtType)
  if (stmtType === STATEMENT_TYPE.entry) {
    return AbiStatementViewApiUrls.GET_ENTRY_SUMMARY_DETAILS 
      + `?entryNumber=${stmtNumber[1]}` 
      + `&statementNumber=${stmtNumber[0]}`
  }
  if (stmtType === STATEMENT_TYPE.daily) {
    return AbiStatementViewApiUrls.GET_DAILY_DETAILS
      + `?statementNumber=${stmtNumber[0]}`
      + `&isFinalized=${stmtNumber[1]}` 
  }
  if (stmtType === STATEMENT_TYPE.monthly) {
    return AbiStatementViewApiUrls.GET_MONTHLY_PRELIMINARY
        + `?statementNumber=${stmtNumber}`
  }
  if (stmtType === STATEMENT_TYPE.pmsDaily) {
    return AbiStatementViewApiUrls.GET_PMS_DAILY_DETAILS
      + `?dailyStatementNumber=${stmtNumber[0]}`
      + `&monthlyStatementNumber=${stmtNumber[1]}`
  }
  
  // FOR KIANYU: CHANGE TO NECESSARY API CALL
  return AbiStatementViewApiUrls[`GET_${stmtType === STATEMENT_TYPE.monthly ? 'MONTHLY' : 'DAILY'}_${finalized ? 'FINALIZED' : 'PRELIMINARY'}`]
    + `?statementNumber=${stmtNumber[0]}`
}
// END INTEGRATION

export const StatementDialogProvider = props => {
  const [pageCache, setPageCache] = useState([])
  const [currentPage, setCurrentPage] = useState(null)

  const pushPage = ({ sections, statementType }) => {
    const arr = [...pageCache]
    arr.push({ sections, statementType })
    setPageCache(arr)
    setCurrentPage(null)
  }
  const previous = () => {
    const arr = [...pageCache]
    setCurrentPage(arr.pop() || null)
    setPageCache(arr)
  }

  const fetchNewPage = async (stmtNumber, stmtType, finalized, isAlive) => {
    if (!stmtNumber || !stmtType)
      return null
    if (currentPage && isAlive)
      pushPage(currentPage)

    //let res = await fetch(getApiUrl(stmtNumber, stmtType, finalized))
    let res = await 
        fetch(getApiUrl(stmtNumber, stmtType, finalized), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
      })
    
    console.log(res);
    res = await res.json()
    if (res.status === 200 && isAlive) {
      setCurrentPage({
        sections: res.data || {},
        statementType: stmtType
      })
    }
  }

  const clearCache = () => {
    setCurrentPage(null)
    setPageCache([])
  }

  return <StatementDialogContext.Provider
    value={{
      fetchNewPage, previous, currentPage,
      hasCache: pageCache.length > 0,
      clearCache,
    }}
    {...props}
  />
}